import { Model } from '@vuex-orm/core'

export default class Config extends Model {
  static entity = 'configs'

  static primaryKey = 'key'

  static fields() {
    return {
      key: this.string(''),
      value: this.attr(null)
    }
  }

  static value(id) {
    return this.getters('value')(id)
  }
}
